const BASE_URL = "/_serverless/ricos-media-services/media-token";
const fetchMediaToken = async (makeRequest) => {
  const response = await makeRequest(BASE_URL);
  if (!response.ok) {
    console.error("Failed to get media token");
    return null;
  }
  const token = (await response.text()).replace(/^"+|"+$/g, "");
  if (token && token.startsWith("JWS.")) {
    return token;
  }
  return null;
};
export {
  fetchMediaToken
};
//# sourceMappingURL=fetch-media-token.js.map
